module.exports = __webpack_public_path__ + "static/img/8.0034892.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/8.png
// module id = YE0e
// module chunks = 0